import { CatalogCardSkeleton } from "./CatalogCardSkeleton";
import { gridClasses } from "./CatalogGrid";
const SKELETON_COUNT = 20;

export function CatalogGridSkeleton() {
  return (
    <div className={gridClasses} data-testid="catalog-grid-skeleton">
      {new Array(SKELETON_COUNT).fill(null).map((_, index) => (
        <CatalogCardSkeleton key={index} />
      ))}
    </div>
  );
}
